export const generateAction = (items = {}, reducer = '') => {
	const actions = {};

	Object.keys(items).map((item) => {
		actions[`${reducer ? `${reducer}_` : ''}${item}_set`] = (values, scope) => ({
			type: `${reducer ? `${reducer.toUpperCase()}/` : ''}${item.toUpperCase()}/SET`,
			payload: { values, scope },
		});
		actions[`${reducer ? `${reducer}_` : ''}${item}_clear`] = (values, scope) => ({
			type: `${reducer ? `${reducer.toUpperCase()}/` : ''}${item.toUpperCase()}/CLEAR`,
			payload: { values, scope },
		});
	});

	return actions;
};
